import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface WordmarkProps {
    className?: string
}

export const Wordmark: FC<WordmarkProps> = ({ className }): ReactNode => {
    return (
        <span
            className={cn(
                'font-heading text-xl font-extrabold tracking-[-0.02em] text-soft-white',
                className
            )}
        >
            BUCKY
            <span className='ml-[0.28em] text-orange'>
                AI
            </span>
        </span>
    )
}
